var map = {
	".": 332,
	"./": 332,
	"./Component": 1045,
	"./Component.js": 1045,
	"./OldUi": 1046,
	"./OldUi.js": 1046,
	"./RenderComponent": 758,
	"./RenderComponent.js": 758,
	"./TopActions": 757,
	"./TopActions.js": 757,
	"./index": 332,
	"./index.js": 332,
	"./style": 427,
	"./style.js": 427
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 4152;
module.exports = webpackAsyncContext;